// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/calendar-check.js';

import { paths } from '../generated/calendar-check';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('calendar-check', Original, paths);
